import { IPermitRequest } from "../interface/permitRequest.interface";
import PermitType from "../types/permit.type";
import useAxiosPrivateToken from "../hooks/usePrivateAxios";
import { IStreets } from "../interface/config/project-config.interface";
import { timeout } from "../helpers/timeout";
import { IApiError } from "../interface/API/apiError.interface";


const CALC_PAYMENT_AMOUNT_API = '/add-citizen-sticker/payment-amount';
const ADD_CITIZEN_STICKER_API = '/add-citizen-sticker/addCitizenSticker';
const GET_STREETS_API = '/add-citizen-sticker/get-streets';

type ResponseAddPermitResponse = {
    success: boolean;
    asmachta: string;
    permitRequestId: number;
    amountPayed: number;
    receiptUrl: string;
    hasReceipt: boolean;
    apiError: IApiError;
};

export interface GetStreetsApiResponse {
    isSuccess: boolean;
    message: string;
    streets: IStreets[];
}

type CalculatePaymentApiResponse = {
    isSuccess: boolean;
    message: string;
    amount: number;
};


export default function useAddPermitRequestPageApi() {

    const { axiosLolatechPortalPrivate, handleError } = useAxiosPrivateToken();


    async function getStreetsApi(extra4: { [x: string]: string }): Promise<GetStreetsApiResponse> {

        const result: GetStreetsApiResponse = {
            isSuccess: true,
            message: '',
            streets: [] as IStreets[],
        };

        try {

            const extra4Json = {
                extra4: extra4,
            }

            const response = await axiosLolatechPortalPrivate.post(GET_STREETS_API, extra4Json);
            const data = await response.data;

            //console.log('getStreetsApi', data);

            if (!data.streets || data.streets.length <= 0)
                throw Error('Unknown problem returned from server');

            result.streets = data.streets ? data.streets : [];
            result.isSuccess = true;

        } catch (error) {

            result.isSuccess = false;
            result.message = error.message;
            console.error(error.message);
        }

        return result
    }

    async function addPermitRequestApi(formData: IPermitRequest): Promise<ResponseAddPermitResponse> {

        const responseAddPermitRequest: ResponseAddPermitResponse = {
            success: false,
            asmachta: '',
            permitRequestId: -1,
            amountPayed: 0,
            receiptUrl: '',
            hasReceipt: false,
            apiError: {
                displayMessage: '',
                errorCode: 0,
                errorName: ''
            }
        }

        try {

            const response = await axiosLolatechPortalPrivate.post(ADD_CITIZEN_STICKER_API, formData);
            const data = await response.data;


            if (!data.permitRequestId || data.permitRequestId <= 0)
                throw Error('Unknown problem returned from server');

            responseAddPermitRequest.asmachta = data.asmachta ? data.asmachta : '';
            responseAddPermitRequest.permitRequestId = data.permitRequestId ? data.permitRequestId : -1;
            responseAddPermitRequest.amountPayed = data.payment ? data.payment : 0;
            responseAddPermitRequest.receiptUrl = data.receiptUrl ? data.receiptUrl : '';
            responseAddPermitRequest.hasReceipt = data.hasReceipt ? data.hasReceipt : false;
            responseAddPermitRequest.success = true;

            return responseAddPermitRequest;
        } catch (error) {

            console.log('Error', error);
            let errorMsg = handleError(error);
            let errorCode = 1;
            let errorName = '';

            responseAddPermitRequest.apiError = {
                displayMessage: errorMsg,
                errorCode: errorCode,
                errorName: errorName
            }

            console.error('responseAddPermitRequest', responseAddPermitRequest);
            return responseAddPermitRequest;
        }
    }

    async function calculatePaymentApi(permitType: PermitType, streetId: string): Promise<CalculatePaymentApiResponse> {

        const reqToSend = {
            permitType: permitType,
            streetId: streetId
        };

        try {

            const response = await axiosLolatechPortalPrivate.post(CALC_PAYMENT_AMOUNT_API, reqToSend);
            const amount = Number(response.data);
            
            return {
                isSuccess: true,
                message: '',
                amount: amount
            }

        } catch (error) {

            console.log('Error', error);
            const errorMsg = handleError(error);

            return {
                isSuccess: false,
                message: errorMsg,
                amount: -1
            }
        }
    }


    return { addPermitRequestApi, calculatePaymentApi, getStreetsApi };
}